import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin-map",
  "use": "pin-map-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"pin-map\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" transform=\"translate(1 1)\"><path d=\"M18 9c0 7-9 13-9 13S0 16 0 9a9 9 0 1 1 18 0z\" /><circle cx=\"9\" cy=\"9\" r=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol